import { ModuleWithProviders, NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { BetslipHost } from '../core/external-betslip-actions';
import { BetslipDigitalModuleLoaderService } from './betslip-digital-module-loader.service';
import ExternalAffiliateEffects from './external-affiliate.effects';
import { ExternalBetslipEffects } from './external-betslip-effects';
import { BETSLIP_MODULE_LOADER_SERVICE } from './sports-injection-services';

@NgModule({
    imports: [EffectsModule.forFeature([ExternalBetslipEffects, ExternalAffiliateEffects])],
})
export class BetslipDigitalIntegrationModule {
    static forRoot(): ModuleWithProviders<BetslipDigitalIntegrationModule> {
        return {
            ngModule: BetslipDigitalIntegrationModule,
            providers: [
                { provide: BetslipHost, useValue: BetslipHost.Digital },

                // services
                { provide: BETSLIP_MODULE_LOADER_SERVICE, useClass: BetslipDigitalModuleLoaderService },
            ],
        };
    }
}
